<template>
	<footer id="theme-footer" class="theme-footer margin-top-xl">
		<div class="margin-auto padding-xl footer-inner container__large">
			<div class="main-columns flex container">
				<div class="col first">
					{{ getOptions.footer_description }}
				</div>
				<div class="col second">
					<div v-if="getOptions.dark_button || getOptions.light_button" class="flex footer-buttons">
						<ColorLink
							v-if="getOptions.light_button && getOptions.light_button.url"
							:icon="false"
							uppercase
							small
							:link="getOptions.light_button"
							color="black"
							outlined
						/>
						<ColorLink
							v-if="getOptions.dark_button && getOptions.dark_button.url"
							:icon="false"
							uppercase
							small
							:link="getOptions.dark_button"
							color="white"
						/>
					</div>
					<div class="footer-contact">
						<a
							rel="nofollow noopener"
							v-if="getOptions.footer_phone"
							:href="'tel:' + getOptions.footer_phone.phoneFormat()"
							class="phone slide-hover slide-hover--always-white"
						>
							{{ getOptions.footer_phone }}
						</a>
						<a
							rel="nofollow noopener"
							v-if="getOptions.footer_email"
							:href="'mailto:' + getOptions.footer_email"
							class="email slide-hover slide-hover--always-white"
						>
							{{ getOptions.footer_email }}
						</a>
					</div>
				</div>
			</div>
			<div class="bottom-columns flex container">
				<WpNavi link-class="slide-hover slide-hover--always-white" class="footer-menu" location="footer-menu" />
				<div class="footer-share" v-if="getOptions.share_module.linkedin || getOptions.share_module.facebook">
					<span class="namer">Følg oss på</span>
					<a
						v-if="getOptions.share_module.linkedin"
						rel="nofollow noopener"
						class="slide-hover slide-hover--always-white"
						:href="getOptions.share_module.linkedin"
					>
						LinkedIn
					</a>
					<span v-if="getOptions.share_module.linkedin && getOptions.share_module.facebook" class="namer sep">
						og
					</span>
					<a
						v-if="getOptions.share_module.facebook"
						rel="nofollow noopener"
						class="slide-hover slide-hover--always-white"
						:href="getOptions.share_module.facebook"
					>
						Facebook
					</a>
				</div>
			</div>
			<svg
				aria-label="toggle dark mode"
				title="toggle dark mode"
				class="dark-theme-switch"
				@click="darkTheme"
				height="448pt"
				viewBox="-12 0 448 448.04455"
				width="448pt"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill="#fff"
					d="m224.023438 448.03125c85.714843.902344 164.011718-48.488281 200.117187-126.230469-22.722656 9.914063-47.332031 14.769531-72.117187 14.230469-97.15625-.109375-175.890626-78.84375-176-176 .972656-65.71875 37.234374-125.832031 94.910156-157.351562-15.554688-1.980469-31.230469-2.867188-46.910156-2.648438-123.714844 0-224.0000005 100.289062-224.0000005 224 0 123.714844 100.2851565 224 224.0000005 224zm0 0"
				/>
			</svg>
		</div>
		<div class="margin-auto footer-cpr flex container__large">
			<div class="info">
				Opphavrett © {{ currentYear }} {{ blogName }}
				<template v-if="policyPage">
					-
					<AcfLink class="slide-hover slide-hover--tiny" :data="policyPage" />
				</template>
			</div>
			<div class="dev">
				Nettside levert av
				<a class="slide-hover slide-hover--tiny" rel="nofollow noopener" href="//frontkom.com">Frontkom</a>
			</div>
		</div>
	</footer>
</template>

<script>
import WpNavi from '@/components/elements/WpNavi'
import AcfLink from '@/components/elements/AcfLink'
import ColorLink from '@/components/elements/ColorLink'

import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'theme-footer',
	components: {
		WpNavi,
		ColorLink,
		AcfLink,
	},
	data() {
		return {
			homeLink: window.WPVUE.home.replace(/\/$/, ''),
			wpvue: window.WPVUE,
			blogName: window.WPVUE.blogname,
			currentYear: new Date().getFullYear(),
		}
	},
	computed: {
		...mapGetters(['getOptions', 'isDarkMode']),
		policyPage() {
			return this.getOptions.privacy_page || false
		},
	},
	methods: {
		...mapMutations(['DARK_MODE']),
		darkTheme() {
			let options = {
				set: !this.isDarkMode,
				cookies: true,
			}
			this.DARK_MODE(options)
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.dark-theme {
	#theme-footer .footer-inner {
		background-color: var(--gray);
		color: var(--dark);
	}
}
#theme-footer {
	position: relative;
	@include mquery($phone) {
		margin-right: -35px;
	}
	.dark-theme-switch {
		width: 20px;
		height: 20px;
		position: absolute;
		cursor: pointer;
		right: 25px;
		bottom: 25px;
		path {
			transition: fill 0.2s ease-in-out;
		}
		&:hover {
			path {
				fill: #888;
			}
		}
	}
	.footer-cpr {
		display: flex;
		justify-content: space-between;
		@include fluid-type($smallResText, $wideResText, 12px, 15px);
		padding-top: 15px;
		padding-bottom: 15px;
		a {
			text-decoration: none;
		}
		@include mquery($phone) {
			display: block;
			.dev {
				margin-top: 5px;
			}
		}
	}
	.bottom-columns {
		margin-top: 50px;
		@include fluid-type($smallResText, $wideResText, 16px, 20px);
		@include mquery($tablet) {
			margin-top: 40px;
		}
		@include mquery($phone) {
			margin-top: 25px;
			display: block;
		}
		.footer-share {
			padding-left: 25px;
			@include mquery($phone) {
				padding-left: 0;
				margin-top: 5px;
			}
		}
		.menu {
			margin-right: auto;
		}
		.wp-navi-links {
			margin: 0;
			padding: 0;
			display: flex;
			list-style: none;
			margin-right: -25px;
			li {
				margin-right: 25px;
			}
			@include mquery($phone) {
				flex-wrap: wrap;
				margin-right: 0;
				li {
					margin-right: 15px;
					margin-bottom: 15px;
				}
			}
		}
	}
	.footer-inner {
		background-color: var(--dark);
		color: var(--light);
		position: relative;
		a {
			color: inherit;
			text-decoration: none;
		}
		@include mquery($phone) {
			padding: 25px;
		}
	}
	.main-columns {
		display: flex;
		.col {
			max-width: 50%;
			width: 100%;
		}
		.first {
			padding-right: 25px;
			@include fluid-type($smallResText, $wideResText, 16px, 18px);
		}
		.second {
			padding-left: 25px;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
		}
		@include mquery($tablet) {
			display: block;
			.col {
				max-width: 100%;
				padding: 0;
			}
			.second {
				margin-top: 25px;
				flex-direction: row;
				justify-content: space-between;
				align-items: initial;
			}
			.footer-buttons {
				margin-bottom: 0;
				display: block;
			}
		}
		@include mquery($phone) {
			.second {
				margin-top: 25px;
				display: block;
			}
			.footer-contact {
				margin-top: 25px;
				text-align: left;
			}
		}
	}
	.footer-buttons {
		margin-bottom: 40px;
		.fill-button:first-child {
			margin-right: 20px;
		}
	}
	.footer-contact {
		display: flex;
		flex-direction: column;
		text-align: right;
		a {
			@include fluid-type($smallResText, $wideResText, 18px, 25px);
		}
	}
}
</style>
